import type { InboxState } from "@/lib/states/global-state"

const DEFAULT_EMPTY_TITLE = "Your inbox is clear"

const EMPTY_TITLES: Partial<Record<InboxState, string>> = {
	new: "Everything is assigned",
	my: "Your queue is clear",
	"close-loop": "Every loop is closed",
	"sla-breached": "Every thread is within SLA",
	snoozed: "Snoozed threads wait here",
	done: "Done threads collect here",
}

export function threadTabEmptyTitle(tab: InboxState): string {
	return EMPTY_TITLES[tab] ?? DEFAULT_EMPTY_TITLE
}
